"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * enum for setting block direction, used by setDirection API
 */
var Direction;
(function (Direction) {
    /**
     * Left to right
     */
    Direction[Direction["LeftToRight"] = 0] = "LeftToRight";
    /**
     * Right to left
     */
    Direction[Direction["RightToLeft"] = 1] = "RightToLeft";
})(Direction = exports.Direction || (exports.Direction = {}));
//# sourceMappingURL=Direction.js.map